import React from "react";
import { motion } from "framer-motion";

/**
 * Shared reveal + overline components — updated for the light design system.
 */
export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 24 },
      show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1], delay },
      },
    }}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionOverline = ({ number, label, testId }) => (
  <div className="flex items-center gap-4">
    <span
      data-testid={testId ? `${testId}-number` : undefined}
      className="font-display forr-text-teal-deep text-sm font-medium"
    >
      {number}
    </span>
    <span className="w-8 h-px" style={{ backgroundColor: "var(--forr-line-strong)" }} />
    <span
      data-testid={testId}
      className="text-[11px] font-semibold uppercase tracking-[0.28em] forr-text-mute"
    >
      {label}
    </span>
  </div>
);
